export function stripDataUrlPrefix(dataUrl: string): { base64: string; mime: string } {
  const m = /^data:([^;]+);base64,(.*)$/s.exec(dataUrl);
  if (m) return { mime: m[1]!, base64: m[2]! };
  return { mime: 'image/jpeg', base64: dataUrl };
}

// Aproxima los bytes decodificados desde el largo del base64.
function approxBytes(base64: string): number {
  return Math.floor((base64.length * 3) / 4);
}

/**
 * Reescala + re-encodea una imagen a JPEG hasta caber en maxBytes.
 * Devuelve base64 SIN el prefijo data:. Requiere navegador (canvas).
 */
export async function compressImageToBase64(file: File, maxBytes = 2_600_000): Promise<{ base64: string; mime: string }> {
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const fr = new FileReader();
    fr.onload = () => resolve(String(fr.result));
    fr.onerror = () => reject(new Error('No se pudo leer la imagen'));
    fr.readAsDataURL(file);
  });

  const img = await new Promise<HTMLImageElement>((resolve, reject) => {
    const i = new Image();
    i.onload = () => resolve(i);
    i.onerror = () => reject(new Error('Imagen inválida'));
    i.src = dataUrl;
  });

  let width = img.naturalWidth || img.width;
  let height = img.naturalHeight || img.height;
  const maxDim = 1600;
  if (Math.max(width, height) > maxDim) {
    const ratio = maxDim / Math.max(width, height);
    width = Math.round(width * ratio);
    height = Math.round(height * ratio);
  }

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    // Sin canvas (entorno raro): usar la original.
    return stripDataUrlPrefix(dataUrl);
  }
  ctx.drawImage(img, 0, 0, width, height);

  for (const quality of [0.8, 0.6, 0.45, 0.3]) {
    const out = canvas.toDataURL('image/jpeg', quality);
    const { base64 } = stripDataUrlPrefix(out);
    if (approxBytes(base64) <= maxBytes) return { base64, mime: 'image/jpeg' };
  }
  const last = canvas.toDataURL('image/jpeg', 0.3);
  return { base64: stripDataUrlPrefix(last).base64, mime: 'image/jpeg' };
}
